import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'crossword',
  gameConfig: dataConfig,
  multiStageGameWeight: 11,
  title: [
    {
      text: 'Rozwiąż krzyżówkę obrazkową. Pisz wielkimi literami. Odczytaj hasło.',
      audio: 'games/page026_game4/audio/z26c4.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page026_game4/audio/z26c4-brawo.mp3',
    // negative: 'games/page000_game0/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
